import {getUrlQuery} from '~/utils/url';
import {googleDimensions} from '~/constants/AnalyticsConstants';
import {fullStory} from '~/vendor/fullstory';
import {__DEVELOPMENT__, __TEST__} from '~/utils/env';
import custominkMetrics  from'@customink/metrics';

const query = getUrlQuery();
let Metrics;
let metrics;

if (
  query.track === 'no' ||
    (import.meta.env.NDX_ENABLE_METRICS !== 'true' && __DEVELOPMENT__)
) {
  Metrics = class {
    fireEvent(category, action, label) {
      const displayLabel = label ? `"${label}"` : '';
      console.log(`Event Fired: "${category}" "${action}" ${displayLabel}`);
    }

    pageViewTag(tag) {
      console.log(`Page View Tag ${tag}`);
    }

    pageTest(tag) {
      console.log(`Page Test created: ${tag}`);
    }

    registerDimension(dimensionName, dimensionValue) {
      console.log(
        `Registered Dimension ${googleDimensions[dimensionName]} ${dimensionName} with value ${dimensionValue}`
      );
    }

    setDimension(dimensionName, dimensionValue) {
      console.log(
        `Set Dimension ${googleDimensions[dimensionName]} ${dimensionName} with value ${dimensionValue}`
      );
    }

    sessionPageViewTag(tag, opts = {}) {
      console.log(`Session Page View Tag ${tag}`);
    }

    registerUser(userId) {
      console.log(`GA userId ${userId}`);
    }

    logInteractionCookie() {
      console.log('Interaction cookie logged');
    }
  };
} else if (__TEST__) {
  Metrics = class {
    fireEvent() {}
    pageViewTag() {}
    pageTest() {}
    registerDimension() {}
    setDimension() {}
    sessionPageViewTag() {}
    registerUser() {}
    logInteractionCookie() {}
  };
} else {
  Metrics = custominkMetrics;
  Metrics.prototype.setDimension = function (dimensionName, dimensionValue) {
    const ga = window.ga;
    if (ga !== undefined && typeof ga === 'function') {
      let gaDimensionName = googleDimensions[dimensionName];
      if (gaDimensionName) {
        gaDimensionName = `dimension${gaDimensionName}`;
        ga('set', gaDimensionName, dimensionValue);
      }
    }
  };
}

class MetricsWrapper {
  constructor(metrics) {
    this.gaMetrics = metrics;
    this.fullStoryMetrics = fullStory;
  }

  pageViewTag(pageViewTag, attributes = {}, logToFullstory = false) {
    this.gaMetrics.pageViewTag(pageViewTag);
    if (logToFullstory) {
      this.fullStoryMetrics.event(pageViewTag, attributes);
    }
  }

  fireEvent(...args) {
    if (!args.length) return;
    this.gaMetrics.fireEvent(...args);
  }

  registerDimension(dimensionName, dimensionValue) {
    this.gaMetrics.registerDimension(dimensionName, dimensionValue);
  }

  setDimension(dimensionName, dimensionValue) {
    this.gaMetrics.setDimension(dimensionName, dimensionValue);
  }

  pageTest(pageTestTag) {
    this.gaMetrics.pageTest(pageTestTag);
  }

  logInteractionCookie() {
    this.gaMetrics.logInteractionCookie();
  }

  registerUser(userId) {
    this.gaMetrics.registerUser(userId);
  }

  sessionPageViewTag(
    sessionPageViewTag,
    attributes = {},
    logToFullstory = false
  ) {
    this.gaMetrics.sessionPageViewTag(sessionPageViewTag);
    if (logToFullstory) {
      this.fullStoryMetrics.event(sessionPageViewTag, attributes);
    }
  }
}

metrics = new MetricsWrapper(new Metrics());

metrics.pageViewTag('ndx/lab/prestart');
metrics.logInteractionCookie();

export {metrics};
